import { useContext } from 'react';
import { Context } from '@components/Context';
import { Timescale } from '@contracts';

export const deliveryTimescales: Timescale[] = [
  {
    timescaleMin: 3,
    timescaleMax: 5,
    currency: 'GBP'
  },
  {
    timescaleMin: 3,
    timescaleMax: 8,
    currency: 'EUR'
  },
  {
    timescaleMin: 4,
    timescaleMax: 7,
    currency: 'USD'
  }
];

const useDeliveryTimescale = () => {
  const { state } = useContext(Context);
  const { currency } = state;

  const getDeliveryTimescale = () => {
    const timescaleForCurrency =
      deliveryTimescales.find((scale) => scale.currency === currency.letterCode) || deliveryTimescales.find((scale) => scale.currency === 'EUR');

    if (!timescaleForCurrency) {
      throw new Error(`No delivery timescale configuration found for currency: ${currency}`);
    }

    return timescaleForCurrency;
  };

  return { getDeliveryTimescale };
};

export default useDeliveryTimescale;
